import React from "react"

export default function TypeConditionalText({ value, description }) {
  return <div>{value}</div>
}
